const filteredCardTypes = {
  lesson: "LESSON",
  subject: "SUBJECT",
};

export default filteredCardTypes;
